import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { GestioneDipartimentiComponent } from './pages/gestione-dipartimenti/gestione-dipartimenti/gestione-dipartimenti.component';
import { DipartimentiListComponent } from './components/dipartimenti-list/dipartimenti-list.component';
import { ModalDepartmentFormComponent } from './components/modal-department-form/modal-department-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DynamicFormModule } from 'src/app/core/components/dynamic-form/dynamic-form.module';
import { CommonTLFModule } from 'src/app/common/common.module';
import { GestioneRuoliComponent } from './pages/gestione-dipartimenti/gestione-ruoli/gestione-ruoli.component';
import { DepartmentsPageComponent } from './pages/gestione-dipartimenti/departments-page/departments-page.component';
import { RuoliListComponent } from './components/ruoli-list/ruoli-list.component';
import { ModalRoleComponent } from './components/modal-role/modal-role.component';
import { DetailDepartmentPageComponent } from './pages/gestione-dipartimenti/detail-department-page/detail-department-page.component';
import { ModalMemberComponent } from './components/modal-member/modal-member.component';
import { PersonModule } from '../person/person.module';
import { DipartimentiRoutingModule } from './dipartimenti-routing.module';
import { SearchRoleDepartmentComponent } from './components/search-role-department/search-role-department.component';
import { MembersListComponent } from './components/members-list/members-list.component';


@NgModule({
  declarations: [GestioneDipartimentiComponent, DipartimentiListComponent, ModalDepartmentFormComponent, GestioneRuoliComponent, DepartmentsPageComponent, RuoliListComponent, ModalRoleComponent, DetailDepartmentPageComponent, ModalMemberComponent, SearchRoleDepartmentComponent, MembersListComponent],
  imports: [
    CommonModule,
    DipartimentiRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    DynamicFormModule,
    CommonTLFModule,
    PersonModule
  ],
  exports: [
    ModalDepartmentFormComponent,
  ]
})
export class DipartimentiModule { }
